import { apiClient } from './api-client';

// 백엔드 CompanySummaryResponse 대응(수동 타입 — openapi.spec.json 미포함, 전체 재생성 drift 회피).
export interface CompanySummary {
  compCd: string;
  compName: string | null;
  brandName: string | null;
  logoUrl: string | null;
  useYn: string | null;
  provisioningStatus: string | null;
}

// 백엔드 CompanyProvisioningResponse 대응.
export interface CompanyProvisioningResult {
  compCd: string;
  status: string;
  companyPersisted: boolean;
  organizationReady: boolean;
  adminProvisioned: boolean;
  adminBootstrapped: boolean;
  organizationId: string | null;
  /** 신규 생성 시에만 1회 채워짐. 재조회 불가 — 즉시 안전한 경로로 전달해야 한다. */
  initialAdminPassword: string | null;
  message: string | null;
}

export interface CreateCompanyInput {
  compCd: string;
  compName: string;
  bizNo?: string;
  repDirector?: string;
  repPhone?: string;
  adminEmail: string;
}

/** 회사(테넌트) 목록 조회 (SUPER_ADMIN 전용). */
export async function fetchCompanies(): Promise<CompanySummary[]> {
  const res = await apiClient.get('admin/company').json<{ result?: CompanySummary[] }>();
  return res.result ?? [];
}

/** 테넌트 온보딩 (멱등·재개 가능). */
export async function createCompany(input: CreateCompanyInput): Promise<CompanyProvisioningResult> {
  const res = await apiClient
    .post('admin/company', { json: input })
    .json<{ result: CompanyProvisioningResult }>();
  return res.result;
}

/** 로고 업로드 — 공개 URL만 반환하며 저장은 updateCompanyBranding으로 확정한다. */
export async function uploadCompanyLogo(compCd: string, file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const res = await apiClient
    .post(`admin/company/${compCd}/logo`, { body: form })
    .json<{ result: string }>();
  return res.result;
}

/** 브랜딩 저장 (DB + KC org attribute write-through). null/빈 값은 해당 브랜딩 제거. */
export async function updateCompanyBranding(
  compCd: string,
  branding: { brandName?: string | null; logoUrl?: string | null }
): Promise<CompanySummary> {
  const res = await apiClient
    .put(`admin/company/${compCd}/branding`, { json: branding })
    .json<{ result: CompanySummary }>();
  return res.result;
}
